class ToDoUserPicker {
  toDoDataMap;
  toDoSubject;
  $container;
  selectedTable;

  constructor({ $container, toDoData, toDoSubject, selectedTable } = {}) {
    this.toDoDataMap = this._createToDoDataMap(toDoData);
    this.toDoSubject = toDoSubject;
    this.$container = $container;
    this.selectedTable = selectedTable;

    this._loadDomListeners($container, toDoData);
  }

  _createToDoDataMap(toDoData) {
    const dataMap = new Map();

    for (const toDo of toDoData) {
      dataMap.set(toDo.todoId, toDo);
    }

    return dataMap;
  }

  static assigneeSort(assigneeA, assigneeB) {
    const userId = Session.getUser().userId;

    if (assigneeA?.id === assigneeB?.id) {
      return 0;
    } else if (assigneeA?.id === userId) {
      return -1;
    } else if (assigneeB?.id === userId) {
      return 1;
    }

    const undefinedSort = SortUtilities.undefinedSort(assigneeB, assigneeA);
    if (undefinedSort !== null) {
      return undefinedSort;
    }

    let result = SortUtilities.alphaSorter(assigneeA.fullName, assigneeB.fullName);
    if (result === 0) {
      result = SortUtilities.numberSorter(assigneeA.id, assigneeB.id);
    }
    return result;
  }

  _loadDomListeners($container) {
    $container
      .off("click", ".user-picker", this._onUserPickerClick)
      .on("click", ".user-picker", this._onUserPickerClick.bind(this));
  }

  _onUserPickerClick(e) {
    const $userBadge = $(e.currentTarget);
    const $selectedRows = this.selectedTable?.getAllSelectedRows();
    const allUsers = this._getAllUsers();
    const pickedToDo = this._getUserPickerDatum($userBadge);
    const toDos = this._getPickedToDos($selectedRows, pickedToDo);

    if ($userBadge.attr("disabled")) {
      return false;
    }

    const $pickerContainer = $(`<div><select class="input-width"></select></div>`);
    const badgePos = $userBadge.offset();
    $pickerContainer.css({
      position: "absolute",
      left: `${badgePos.left}px`,
      top: `${badgePos.top}px`,
    });
    $("body").append($pickerContainer);

    $pickerContainer
      .find("select")
      .select2({
        data: this._getUserSelectOptions(allUsers, pickedToDo?.assignee?.id),
        closeOnSelect: false,
      })
      .on("select2:select", (e) => {
        const selectedId = parseInt(e.params.data.id);
        this._selectUser(
          allUsers.find((user) => user.id === selectedId),
          toDos,
        );
        this._destroySelect($pickerContainer);
      })
      .on("select2:close", () => {
        this._destroySelect($pickerContainer);
      })
      .select2("open");
  }

  _getPickedToDos($selectedRows, pickedToDo) {
    const selectedToDos = [];
    let includesPicked = false;

    for (const userPicker of $selectedRows?.find(".user-picker") ?? []) {
      const toDo = this._getUserPickerDatum($(userPicker));
      selectedToDos.push(toDo);

      if (toDo.id === pickedToDo.id) {
        includesPicked = true;
      }
    }

    if (!includesPicked) {
      return [pickedToDo];
    }

    return selectedToDos;
  }

  _getUserPickerDatum($userBadge) {
    const toDoId = $userBadge.data("id");
    return this.toDoDataMap.get(toDoId);
  }

  _getAllUsers() {
    const allUsers = ToolSettings.getSetting("group", "users");
    const toDoConfig = ToDoConfig.getToDoSubjectConfig([this.toDoSubject]);
    const currentTool = Tree.get("tool");

    return allUsers.filter((user) => {
      if (!user.tools.includes(currentTool)) {
        return false;
      }

      const userWithPermissions = {
        ...user,
        permissions: {
          ...user.permissions,
          ...UserRoles.getPermissionsForRole(user.userRole),
        },
      };
      return toDoConfig.canAccessCallback(userWithPermissions);
    });
  }

  _selectUser(assignee, toDos) {
    const apiSubject = ToDoConfig.getToDoSubjectConfig([this.toDoSubject, "apiSubjectName"]);
    const todoIds = [];

    for (const toDo of toDos) {
      if (toDo) {
        toDo.assignee = assignee;
      }
      this._renderUserBadge(assignee, toDo.todoId);
      todoIds.push(toDo.todoId);
    }

    this.selectedTable?.toggleAllRows(false);
    ToDoListController.updateToDoData(this.toDoSubject, todoIds, function (todo) {
      todo.assignee = assignee;
    });
    ApiCalls.updateTodo(todoIds, apiSubject, { assigneeUserId: assignee?.id ?? null });
  }

  _destroySelect($pickerContainer) {
    $pickerContainer.find("select").select2("destroy");
    $pickerContainer.remove();
  }

  _renderUserBadge(assignee, toDoId) {
    const newBadgeHtml = nunjucks.render(`macros/macroTemplates/assignTaskPicker.njk`, {
      todoId: toDoId,
      assigneeFullName: assignee?.fullName,
    });

    this.$container.find(`.user-picker[data-id="${toDoId}"]`).replaceWith(newBadgeHtml);
  }

  _getUserSelectOptions(allUsers, assignedId) {
    const options = [{ text: "Unassigned", selected: !assignedId, id: 0 }];

    for (const user of allUsers.sort(ToDoUserPicker.assigneeSort)) {
      options.push({
        text: user.fullName,
        selected: user.id === assignedId,
        id: user.id,
      });
    }

    return options;
  }
}

module.exports = ToDoUserPicker;

const ApiCalls = require("../apiCalls");
const Session = require("../login/session");
const ToDoConfig = require("../config/toDoConfig");
const ToolSettings = require("../settings/toolSettings");
const SortUtilities = require("./sortUtilities");
const ToDoListController = require("../mapFunctions/toDoListController");
const UserRoles = require("../login/userRoles");
const Tree = require("../tree");
